import { useParams } from "react-router-dom"
import { useHealedDetail } from "@/hooks/useHealedDetail"
import { useArtists } from "@/hooks/useArtists"
import { useDynamicMetaTags } from "@/hooks/useDynamicMetaTags"
import { formatArtistDisplayName } from "@/lib/utils"
import { useToast, Toast } from "@/components/ui/toast"
import { HealedDetailContent } from "@/components/details/HealedDetailContent"

export default function HealedDetailPage() {
  const { healedId } = useParams<{ healedId: string }>()
  const { healed } = useHealedDetail(healedId)
  const { artists } = useArtists(healed ? [healed.artistId] : [])
  const { toast, hideToast } = useToast()

  const artist = artists[0]

  useDynamicMetaTags({
    title: healed && artist ? `${formatArtistDisplayName(artist) || artist.displayName} - Healed Tattoo` : undefined,
    description: healed ? `Check out this healed tattoo by ${formatArtistDisplayName(artist) || 'the artist'}` : undefined,
    image: healed?.imageUrl,
    url: healed ? `https://getmoretats.com/healed/${healed.id}` : undefined,
    type: 'article'
  })

  if (!healedId) return null

  return (
    <>
      <HealedDetailContent healedId={healedId} />
      <Toast {...toast} onClose={hideToast} />
    </>
  )
}

